import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unshift.js";
export const customMerge = (targetVal, srcVal) => {
  if (Array.isArray(srcVal)) {
    return srcVal;
  }
};
export const isCalculated = element => {
  const defaultVal = element && element.options && element.options.defaultVal;
  return !!(defaultVal && Array.isArray(defaultVal) && defaultVal[0] === 'calc');
};
export const getDefaultValue = element => {
  const defaultVal = element && element.options && element.options.defaultVal; // 默认属性

  if (defaultVal && Array.isArray(defaultVal)) {
    const type = defaultVal[0];

    if (type === 'custom') {
      return defaultVal[1];
    }

    if (type === 'calc') {
      // 通过计算得到，不需要在此处进行处理
      return undefined;
    }
  }

  return defaultVal;
};
export const readDataFromListPath = (listPath, obj) => {
  const segment = listPath.split('>').map(item => item.trim());
  let current = obj;

  while (segment.length > 0) {
    current = current[segment.shift()];

    if (!current) {
      return [];
    }
  }

  return current;
};
/**
 * 树处理：平铺结构转为嵌套结构
 */

export const flatToTree = (list = [], rootPid = '') => {
  const treeMap = list.reduce((ret, item) => ({ ...ret,
    [item.id]: item
  }), {});
  const toDel = [];
  list.forEach((item, index) => {
    if (item.pId !== rootPid) {
      const parent = treeMap[item.pId];

      if (parent) {
        parent.children = parent.children || [];
        parent.children.push(item);
        toDel.unshift(index);
      }
    }
  });
  toDel.forEach(index => {
    list.splice(index, 1);
  });
  return list;
};